import { render, staticRenderFns } from "./contentShare.vue?vue&type=template&id=64027fc0"
import script from "./contentShare.vue?vue&type=script&lang=js"
export * from "./contentShare.vue?vue&type=script&lang=js"
import style0 from "./contentShare.vue?vue&type=style&index=0&id=64027fc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports